import { RG_TYPE } from '../../types/rg-type.js';

/** list of objects who's transforms follow the rules of a module */
const ModuleLikeTransform = [
    RG_TYPE.Module,
    RG_TYPE.Balcony,
    RG_TYPE.Core,
    RG_TYPE.Corridor,
    RG_TYPE.Entrance
];

export { ModuleLikeTransform };
//# sourceMappingURL=module-like-transform.js.map
